// src/api/permissionApi.js
import apiClient from "./axios";

const permissionApi = {
  /* ---------- GET ---------- */
  getByRole: async (roleId, page = 1, pageSize = 100) => {
    const response = await apiClient.get("/permissions/", {
      params: { role: roleId, page, page_size: pageSize },
    });
    // API returns { data: [...], pagination: {...} }
    return response.data;
  },

  /* ---------- CREATE ---------- */
  create: async (payload) => {
    const response = await apiClient.post("/permissions/", payload);
    return response.data; // the newly created permission object
  },

  // NEW: BULK CREATE permissions
  bulkCreate: async (payload) => {
    const response = await apiClient.post("/permissions/bulk_create/", payload);
    return response.data;
  },

  /* ---------- UPDATE (single) ---------- */ 
  update: async (permissionId, payload) => {
    const response = await apiClient.patch(
      `/permissions/${permissionId}/`,
      payload
    );
    return response.data;
  },

  /* ---------- DELETE ---------- */
  delete: async (permissionId) => {
    await apiClient.delete(`/permissions/${permissionId}/`);
  },

  /* ---------- OPTIONS (resource choices) ---------- */
  getOptions: async () => {
    const r = await apiClient.options("/permissions/");
    return r.data; // the whole OPTIONS payload
  },

  /* ---------- BULK UPDATE (POST to bulk endpoint) ---------- */
  bulkUpdate: async (payload) => {
    const r = await apiClient.patch("/permissions/bulk-update/", payload);
    return r.data; // backend returns updated objects or empty
  },
};

export default permissionApi;
